import React from 'react';
import styled from 'styled-components';

import Skeleton from '@front/web-ui/src/components/skeleton/skeleton';

import { calculationLineStyle } from '../../../common';

const CalculationLine = styled.div`
  ${calculationLineStyle}
`;

type PriceLineProps = {
  label: React.ReactNode;
  value: React.ReactNode;
  isLoading: boolean;
};

export const PriceLine = ({ label, value, isLoading }: PriceLineProps) => (
  <CalculationLine>
    {label}
    {isLoading ? <Skeleton linesWidth={['50px']} /> : value}
  </CalculationLine>
);
